export default __webpack_public_path__ + "static/media/BACKFINAL.a5b08905.png";